import moment from 'moment'

const PublishDateCell = () => {
  return ({ publish_timestamp }) => {
    return (
      publish_timestamp
        ? moment(publish_timestamp * 1000).format('DD-MMM-YY HH:mm')
        : null
    )
  }
}

export default PublishDateCell
